import { RGTheme } from "@silevis/reactgrid/dist/types/RGTheme";

export const revenueGridStyles = {
  rgStyles: {
    // cellContainer: {
    //   padding: {
    //     top: "0.75rem !important",
    //     right: "0.75rem !important",
    //     left: "0.75rem !important",
    //     bottom: "0.75rem !important",
    //   },
    // },
    fillHandle: {
      background: "transparent",
      border: {
        color: "#f73e77",
        style: "dashed",
        width: "2px",
      },
    },
    focusIndicator: {
      background: "transparent",
      border: {
        color: "#f73e77",
        style: "solid",
        width: "2px",
      },
    },
    area: {
      border: {
        color: "#d4d4d4",
        style: "solid",
        width: "1px",
      },
    },
    selectionIndicator: {
      background: "rgba(247, 62, 119, 0.1)",
      border: {
        color: "#fdc4d6",
        style: "solid",
        width: "2px",
      },
    },
    gridWrapper: {
      fontSize: "0.8125rem",
      fontFamily: "Work Sans",
      fontWeight: 500,
      fontStyle: "normal",
      borderRadius: "0.5rem",
    },
  } as RGTheme,
};
